import { CommunityAssociation, Organization } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CommunityEntityConfig } from "./config";
import { CommunityFilters } from "./filters";
import { CommunityMethods } from "./methods";

@HyperEntity<Community>("community", CommunityEntityConfig)
export class Community extends extender(CommunityFilters, CommunityMethods) {
  @Fields.uuid()
  id = "";

  @Fields.string({ dbName: "organization_id" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({
    dbName: "parent_community_id",
    allowNull: true,
    valueConverter: {
      toDb: (val) => (val === "" || val == null ? null : val),
      fromDb: (val) => (val == null ? "" : val),
    },
  })
  parentCommunityId = "";

  @Relations.toOne(() => Community, { field: "parentCommunityId" })
  parentCommunity?: Community;

  @Relations.toMany(() => Community, {
    field: "parentCommunityId",
    caption: "קהילות בנות",
  })
  childCommunities?: Community[];

  @Relations.toMany(() => CommunityAssociation, {
    field: "communityId",
    caption: "מתנדבים",
  })
  associations?: CommunityAssociation[];

  @Fields.string({ caption: "שם" })
  name = "";

  @Fields.string({ caption: "תיאור" })
  description = "";

  @Fields.string({
    dbName: "join_process_logo_image_id",
    allowNull: true,
    valueConverter: {
      toDb: (val) => (val === "" || val == null ? null : val),
      fromDb: (val) => (val == null ? "" : val),
    },
  })
  joinProcessLogoImageId = "";

  @Fields.string({
    dbName: "join_process_text",
    caption: "הסבר תהליך הצטרפות (קישור הרשמה)",
  })
  joinProcessText = "";

  @Fields.boolean({
    dbName: "short_registration",
    caption: "הרשמה מקוצרת",
  })
  shortRegistration = false;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
